import type { ThresholdPoint } from "@modules/energy-manager/types/alarme"

/**
 * Série de profil / seuil initialisée à zéro (format API métier).
 *
 * @param length nombre de pas (7 ou 168 selon la fréquence)
 * @returns points avec timestamps 0…length-1
 */
export function createEmptyThresholdPoints(length: number): ThresholdPoint[] {
    return Array.from({ length }, (_, timestamp) => ({
        timestamp,
        consigne: 0,
        limhaute: 0,
        limbasse: 0,
    }))
}
